export const displayOnStep = (number) => number > 1;
